import React, { useState } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Input,
  Select,
} from '@lockerpm/design';

import {
  SearchOutlined
} from "@ant-design/icons";

import commonComponents from "../../../../../components/common";

const Filter = (props) => {
  const { OnboardingTooltip, Sort } = commonComponents;
  const { t } = useTranslation()
  const {
    className = '',
    loading = false,
    params = {},
    environments = [],
    setParams = () => { }
  } = props;

  const [key, setKey] = useState(params.key);

  let searchTimeOut = null;

  return (
    <Row
      className={`filter ${className}`}
      justify={'space-between'}
      align={'bottom'}
      gutter={[12, 12]}
    >
      <Col xl={18} lg={18} md={16} xs={24}>
        <Row
          justify={'left'}
          gutter={[12, 12]}
        >
          <Col xl={6} lg={8} md={10} xs={12}>
            <p className="font-semibold mb-1">{t('secret.key')}</p>
            <Input
              prefix={<SearchOutlined />}
              value={key}
              placeholder={t('placeholder.enter')}
              onChange={(e) => {
                setKey(e.target.value);
                if (searchTimeOut) {
                  clearTimeout(searchTimeOut);
                  searchTimeOut = null;
                } else {
                  searchTimeOut = setTimeout(() => {
                    setParams({ ...params, key: e.target.value })
                  }, 500)
                }
              }}
            />
          </Col>
          <Col xl={6} lg={8} md={10} xs={12}>
            <p className="font-semibold mb-1">{t('secret.environment')}</p>
            <Select
              placeholder={t('placeholder.select')}
              className="w-full"
              value={params.environmentId}
              allowClear
              onChange={(v) => setParams({ ...params, environmentId: v })}
            >
              <Select.Option
                value={""}
              >
                <OnboardingTooltip
                  title={t('onboarding.env_all_default')}
                  placement="right"
                  content={
                    <div className='w-full'>
                      {t('common.all_default')}
                    </div>
                  }
                />
              </Select.Option>
              {environments.map((env) => (
                <Select.Option
                  value={env.id}
                  key={env.id}
                >
                  {env.environment.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </Col>
      <Col className="flex items-end mb-[1px]">
        <Sort
          loading={loading}
          params={params}
          setParams={setParams}
        />
      </Col>
    </Row>
  );
}

export default Filter;
